module.exports = __webpack_public_path__ + "static/media/3545.6a80ba55.jpg";